import { COLORS } from '../../settings/common';

export function Schema() {
  return {
    category: 'Text',
    label: 'Icon Row',
    key: 'icon-row',
    previewSrc:
      'https://cdn.shopify.com/s/files/1/0671/5074/1778/files/icon-row-preview.jpg?v=1675730317',
    fields: [
      {
        label: 'Heading',
        name: 'heading',
        component: 'text',
        defaultValue: 'Icon Row Heading',
      },
      {
        label: 'Subtext',
        name: 'subtext',
        component: 'markdown',
        defaultValue:
          'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      },
      {
        label: 'Icons',
        name: 'icons',
        component: 'group-list',
        itemProps: {
          label: '{{item.icon}}',
        },
        fields: [
          {
            label: 'Icon',
            name: 'icon',
            component: 'select',
            options: [
              { label: 'Shipping', value: 'shipping' },
              { label: 'Customer Service', value: 'customer-service' },
              { label: 'Warranty', value: 'warranty' },
              { label: 'Innovation', value: 'innovation' },
            ],
          },
          {
            label: 'Label',
            name: 'label',
            component: 'text',
          },
        ],
        defaultValue: [
          { icon: 'shipping', label: 'Free Shipping' },
          { icon: 'customer-service', label: 'Top Customer Service' },
          { icon: 'warranty', label: 'Lifetime Warranty' },
          { icon: 'innovation', label: 'Innovative Designs' },
        ],
        defaultItem: { icon: 'shipping', label: 'New Icon' },
      },
      {
        label: 'Section Settings',
        name: 'section',
        component: 'group',
        description: 'Background color, text color, icon color, full width',
        fields: [
          {
            label: 'Background Color',
            name: 'bgColor',
            component: 'select',
            options: COLORS,
          },
          {
            label: 'Text Color',
            name: 'textColor',
            component: 'select',
            options: COLORS,
          },
          {
            label: 'Icon Color',
            name: 'iconColor',
            component: 'select',
            options: COLORS,
          },
          {
            label: 'Full Width',
            name: 'fullWidth',
            component: 'toggle',
            description: 'Removes max width of this section',
            toggleLabels: {
              true: 'On',
              false: 'Off',
            },
          },
          {
            label: 'Spacing',
            name: 'spacing',
            component: 'select',
            description: 'Addjust space around this section',
            options: [
              { label: 'Vertical padding', value: 'py-contained' },
              { label: 'Remove top padding', value: 'py-contained !pt-0' },
              { label: 'Remove bottom padding', value: 'py-contained !pb-0' },
            ],
          },
          {
            label: 'Content Alignment (tablet/desktop)',
            name: 'alignmentDesktop',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: [
              { label: 'Left', value: 'md:text-left md:items-start md:mx-0' },
              {
                label: 'Center',
                value: 'md:text-center md:items-center md:mx-auto',
              },
              { label: 'Right', value: 'md:text-right md:items-end md:mx-0' },
            ],
          },
          {
            label: 'Content Alignment (mobile)',
            name: 'alignmentMobile',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: [
              { label: 'Left', value: 'text-left items-start' },
              { label: 'Center', value: 'text-center items-center mx-auto' },
              { label: 'Right', value: 'text-right items-end' },
            ],
          },
          {
            label: 'Icon Position',
            name: 'iconPosition',
            component: 'radio-group',
            variant: 'radio',
            options: [
              { label: 'Vertical', value: 'flex-col' },
              { label: 'Horizontal', value: 'flex-row' },
            ],
          },
        ],
        defaultValue: {
          bgColor: 'var(--off-white)',
          textColor: 'var(--text)',
          iconColor: 'var(--primary)',
          fullWidth: false,
          spacing: 'py-contained',
          alignmentDesktop: 'md:text-center md:items-center md:mx-auto',
          alignmentMobile: 'text-center items-center mx-auto',
          iconPosition: 'flex-col',
        },
      },
    ],
  };
}
